module.exports = __webpack_public_path__ + "img/money-back-guarantee.dc5c34d1.png";